import { Controller } from 'stimulus';

class SignupFormController extends Controller {
  connect() {
    this.eventTypeId = null;
    this.eventShowTitles = [];
    this.maximumTeamMembers = 999;
  }

  onEventTypeChange({ target }) {
    this.eventTypeId = parseInt(target.value, 10);
    this.maximumTeamMembers = parseInt(target.dataset.maximumTeamMembers, 10);

    this.toggleEvents();
  }

  onEventCategoryChange({ target }) {
    this.eventCategoryId = parseInt(target.value, 10);

    this.toggleEvents();
  }

  onEventShowChange({ target }) {
    const exists = this.eventShowTitles.includes(target.value);

    if (exists) {
      this.eventShowTitles = this.eventShowTitles.filter((title) => title !== target.value);
    } else {
      this.eventShowTitles = [...this.eventShowTitles, target.value];
    }

    this.toggleEventShows();
  }

  toggleEvents() {
    this.eventTargets.forEach((event) => {
      const eventTypeId = parseInt(event.dataset.eventTypeId, 10);
      const eventCategoryId = parseInt(event.dataset.eventCategoryId, 10);

      const isVisible = (
        (!this.eventTypeId || eventTypeId === this.eventTypeId)
        && (!this.eventCategoryId || eventCategoryId === this.eventCategoryId)
      );

      event.hidden = !isVisible;
    });
  }

  toggleEventShows() {
    this.eventShowTargets.forEach((eventShow) => {
      const title = eventShow.dataset.eventShowTitle;

      const isVisible = !this.eventShowTitles.length || this.eventShowTitles.includes(title);

      eventShow.hidden = !isVisible;
    });
  }
}

SignupFormController.targets = [
  'event',
  'eventShow',
  'eventType',
  'teamMembers',
  'eventShowInput',
  'teamMembersWrapper',
];

export default SignupFormController;
